import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'Utils/store'
import { multiSelectSlice } from 'Slices/multiSelectSlice'
import PhoneTCPAConsentConfig from 'Configs/fields/phone_tcpa_consent.json'
import { ContractSource } from 'Types/contractTypes'

const contractSource = ContractSource.candidates

const transformValues = function (selectedValues) {
  return selectedValues.map((value) => (value === 'None Selected' ? '' : value))
}

export const PhoneTCPAConsentSlice = multiSelectSlice(
  PhoneTCPAConsentConfig.column,
  'setPhoneTCPAConsent',
  PhoneTCPAConsentConfig.data,
  PhoneTCPAConsentConfig.meta,
  transformValues
)

export const selectPhoneTCPAConsent = createSelector(
  ({ onDemandFilter: { prospectProfile } }: RootState) =>
    prospectProfile.phoneTCPAConsent.selectedValues,
  (
    selectedValues: string[]
  ): {
    selectedValues: string[]
    values: string[]
    audienceTypes: string[]
    label
  } => {
    return {
      selectedValues,
      values: PhoneTCPAConsentConfig.data,
      audienceTypes: PhoneTCPAConsentConfig.source[contractSource].audience_types,
      label: PhoneTCPAConsentConfig.meta.label,
    }
  }
)

export const { setPhoneTCPAConsent } = PhoneTCPAConsentSlice.actions

export default PhoneTCPAConsentSlice.reducer
